import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const appVersionApi = createApi({
  reducerPath: 'appVersionApi',
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getAppVersion: builder.query({
      query: () => ({
        url: urls.appVersion,
        method: 'GET',
        // background check: no error page, toast or global fetching state
        silent: true,
      }),
      transformResponse: (response) => response?.data?.version ?? null,
    }),
  }),
});

export const { useGetAppVersionQuery } = appVersionApi;
